import AddAPhotoIcon from '@mui/icons-material/AddAPhoto';
import DeleteIcon from '@mui/icons-material/Delete';
import EditIcon from '@mui/icons-material/Edit';
import ReplayIcon from '@mui/icons-material/Replay';
import * as Styles from './CandidateProfilePictureManager.styles';
import DialogBox from '../DialogBox';
import PictureUpload from '../PictureUpload';

type CandidateProfilePictureManagerProps = {
  onSelectCandidateProfilePicture: (image: any) => void;
  isUploadPictureOpen: boolean;
  onCloseUploadModal: () => void;
  onOpenUploadModal: () => void;
  isEditingOptionOpen: boolean;
  onOpenEditingOptions: () => void;
  isDeleteModalOpen: boolean;
  onOpenDeleteModal: () => void;
  onCloseDeleteModal: () => void;
  onDeleteCandidatePicture: () => void;
  pictureUrl?: string;
  firstName: string;
  lastName: string;
  isSaving?: boolean;
  isDeleting?: boolean;
  pictureIsEditable?: boolean;
};

export default function CandidateProfilePictureManagerComponent({
  isDeleting,
  isSaving,
  onSelectCandidateProfilePicture,
  isUploadPictureOpen,
  onCloseUploadModal,
  onOpenUploadModal,
  isEditingOptionOpen,
  onOpenEditingOptions,
  isDeleteModalOpen,
  onOpenDeleteModal,
  onCloseDeleteModal,
  onDeleteCandidatePicture,
  pictureUrl,
  firstName,
  lastName,
  pictureIsEditable = false,
}: CandidateProfilePictureManagerProps): JSX.Element {
  const ButtonIcon = pictureUrl ? EditIcon : AddAPhotoIcon;
  const ButtonAction = pictureUrl ? onOpenEditingOptions : onOpenUploadModal;

  return (
    <div id="candidate-profile-picture-manager">
      <Styles.ProfilePictureArea>
        <Styles.UserAvatar
          size={48}
          pictureUrl={pictureUrl ?? ''}
          data-testid="candidate-initials"
          firstName={firstName}
          lastName={lastName ?? ''}
        />

        {pictureIsEditable && (
          <Styles.UploadProfilePictureButton
            onClick={ButtonAction}
            isUploadPictureOpen={isUploadPictureOpen || isEditingOptionOpen}
            hasPictureUploaded={!!pictureUrl}
          >
            <ButtonIcon sx={{ color: '#fff', position: 'relative', top: '2px' }} />
          </Styles.UploadProfilePictureButton>
        )}

        {isEditingOptionOpen && (
          <Styles.FloatingButtons>
            <Styles.FloatingButton onClick={onOpenUploadModal} type="button">
              <ReplayIcon />
              Replace
            </Styles.FloatingButton>
            <Styles.FloatingButton onClick={onOpenDeleteModal} isRedColor type="button">
              <DeleteIcon />
              Delete
            </Styles.FloatingButton>
          </Styles.FloatingButtons>
        )}
        <DialogBox
          isSubmitting={isDeleting}
          onConfirmHandler={onDeleteCandidatePicture}
          isOpen={isDeleteModalOpen}
          onCancelHandler={onCloseDeleteModal}
        />
      </Styles.ProfilePictureArea>
      <PictureUpload
        isSaving={isSaving}
        onClose={onCloseUploadModal}
        isOpen={isUploadPictureOpen}
        onSelectCandidateProfilePicture={onSelectCandidateProfilePicture}
      />
    </div>
  );
}
